import { css } from '@emotion/core'
import styled from '@emotion/styled'
import 'rc-slider/assets/index.css'

import { palette, spacing } from 'main/ui'
import { Text } from '../typography'

const primaryColor = palette.skyBlue2
const trackColor = palette.chrome

const sliderInnerIconSize = 6
const sliderSize = 22
const trackExtensionBorderRadius = 10
const trackExtensionSize = sliderSize / 2
const trackHeight = 4

const trackExtensionStyles = css`
  background: ${trackColor};
  content: '';
  height: ${trackHeight}px;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: ${trackExtensionSize}px;
`

interface ISliderContainerProps {
  isRangeSlider?: boolean
  isCentered?: boolean
}

export const HandlerStyles = {
  background: `${palette.white}`,
  border: `2px solid ${primaryColor}`,
  height: `${sliderSize}px`,
  marginTop: '-9px',
  width: `${sliderSize}px`,
  boxShadow: 'none',
}

export const RailStyles = {
  background: `${trackColor}`,
  height: `${trackHeight}px`,
}

export const TrackStyles = {
  background: `${primaryColor}`,
  height: `${trackHeight}px`,
}

export const SliderContainer = styled.div<ISliderContainerProps>`
  ${props => (props.isCentered ? 'margin: 0 auto;' : '')}
  width: calc(100% - ${trackExtensionSize * 2}px);
  .rc-slider-handle {
    &:after {
      background: ${primaryColor};
      content: '';
      height: ${sliderInnerIconSize}px;
      left: 50%;
      margin-left: -${sliderInnerIconSize / 2}px;
      margin-top: -${sliderInnerIconSize / 2}px;
      position: absolute;
      top: 50%;
      width: ${sliderInnerIconSize}px;
    }
  }
  .input-range__slider {
    background: ${palette.white};
    border: 2px solid ${primaryColor};
    box-sizing: border-box;
    height: ${sliderSize}px;
    margin-left: ${-sliderSize / 2}px;
    margin-top: ${-sliderSize / 2 - trackHeight / 2}px;
    width: ${sliderSize}px;
    // Ensure slider is above track extensions.
    z-index: 1;
    // Inner icon
    &:after {
      background: ${primaryColor};
      content: '';
      height: ${sliderInnerIconSize}px;
      left: 50%;
      margin-left: -${sliderInnerIconSize / 2}px;
      margin-top: -${sliderInnerIconSize / 2}px;
      position: absolute;
      top: 50%;
      width: ${sliderInnerIconSize}px;
    }
  }
  .input-range__track {
    background: ${trackColor};
    border-radius: 0;
    height: ${trackHeight}px;
  }
  .input-range__track--background {
    // Left track extension
    &:before {
      ${trackExtensionStyles}
      ${props => (props.isRangeSlider ? '' : `background: ${primaryColor}`)};
      border-top-left-radius: ${trackExtensionBorderRadius}px;
      border-bottom-left-radius: ${trackExtensionBorderRadius}px;
      left: ${-trackExtensionSize}px;
    }
    // Right track extension
    &:after {
      ${trackExtensionStyles}
      border-top-right-radius: ${trackExtensionBorderRadius}px;
      border-bottom-right-radius: ${trackExtensionBorderRadius}px;
      right: -${trackExtensionSize}px;
    }
  }
  .input-range__track--active {
    background: ${primaryColor};
  }
`

export const ValueContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${spacing.majorScale(1)}px;
`

export const Value = styled(Text)`
  color: ${palette.slate};
`
